const search = window.location.search.substring(1);
const convertPathname = (pathname: string) => {
  return {
    pathname: `${pathname ? '/' + pathname : ''}`,
    search: '?' + search,
  };
};

export const PATH = {
  ONBOARDING: convertPathname('onboarding'),
  DEFAULT: convertPathname('dashboard'),
 SETTINGS__CHECKOUT: convertPathname('general-settings'),
  SETTINGS__EMAIL: convertPathname('general-settings/email'),
  SETTINGS__DELIVERY_VALIDATION: convertPathname('general-settings/delivery-validation'),
  SETTINGS__ORDER_MANAGEMENT: convertPathname('general-settings/order-management'),
  SETTINGS__ADVANCED_SETTING: convertPathname('general-settings/advanced-setting'),
  LOCATIONS: convertPathname('locations'),
  PICKUP: convertPathname('locations/pickup-settings'),
  DELIVERY: convertPathname('locations/delivery-setting'),
  WIDGET: convertPathname('widget-appearance'),
  SHIPPING: convertPathname('shipping'),
  REPORT: convertPathname('order-report'),
  PRICING: convertPathname('pricing'),
  TRANSLATION: convertPathname('translation'),
  CUSTOM_NOTI_PICKUP_EMAIL: convertPathname('general-settings/email/pickup'),
  CUSTOM_NOTI_DELIVERY_SHIPPING_EMAIL: convertPathname('general-settings/email/delivery-shipping'),
};
